import { NumberFormat } from "@design-system/NumberFormat/NumberFormat";
import styles from "./ScheduleAmountInput.module.scss";
import { ScheduleNumericInput } from "./ScheduleNumericInput";

interface ScheduleAmountInputProps {
    value: number | undefined;
    /** Only user edits, not the formatter's own reformatting. */
    onValueChange: (amount: number) => void;
    onBlur?: () => void;
    isReadOnly?: boolean;
    isInvalid?: boolean;
    name?: string;
    "aria-label"?: string;
}

/** The compact `$1,000.00` input of a recognition row, shared with billing. */
export const ScheduleAmountInput = ({
    value,
    onValueChange,
    onBlur,
    isReadOnly = false,
    isInvalid = false,
    name,
    "aria-label": ariaLabel,
}: ScheduleAmountInputProps) => (
    <NumberFormat
        value={value}
        onValueChange={(numberValues, sourceInfo) => {
            if (sourceInfo.event != null) {
                onValueChange(numberValues.floatValue ?? 0);
            }
        }}
        onBlur={onBlur}
        prefix="$"
        decimalScale={2}
        thousandSeparator
        allowNegative={false}
        name={name}
        aria-label={ariaLabel}
        aria-invalid={isInvalid || undefined}
        readOnly={isReadOnly}
        customInput={ScheduleNumericInput}
        className={styles.amountInput}
    />
);
